<template>
    <v-dialog 
        v-model="not.notShow" 
        max-width="450"                     
        :persistent='not.notHd'  >
        <v-card>
        <v-card-title class="headline"
         primary-title
        >{{not.notH}}</v-card-title>
          
        <v-card-text>{{not.notTx}}</v-card-text>
        
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="not.notNoTx!==''"
                @click="onNotNo"
                color="blue" 
                text="">{{not.notNoTx}}</v-btn>
            <v-btn v-if="not.notYesTx!==''"
                @click="onNotYes"
                color="blue" 
                text="">{{not.notYesTx}}</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props:['notShow','notHd','notH','notTx','notNoTx','notYesTx'], 
    data(){
        return{
            show:false
        } 
    }, 
    computed:{
        not(){
            return  this.$store.getters.getNotDialog
        }
    },
    methods:{
        onNotNo(){
            this.EventBus.$emit('notNoDialog',this.not.notAction) 
            this.$store.dispatch('setNotDialog',{})
        },
        onNotYes(){
            this.EventBus.$emit('notYesDialog',this.not.notAction) 
            this.$store.dispatch('setNotDialog',{})
        }
    },
    watch:{
        not(value){
           // console.log(value,"wwwwwwwwww");  
        },
         
    } 
}
</script>
